// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonetizationPopup__container-c27ef3 {
  display: flex;
  flex-direction: column;
  max-width: var(--message-bubble-max-width);
  width: 100%;
  overflow: hidden;
  flex: 0 1 auto;
}

.MonetizationPopup__content-e969b1 {
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: auto;
}

.MonetizationPopup__caption-e1da1f {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
  margin-bottom: 16px;
}

.MonetizationPopup__link-a3ab62 {
  text-decoration: none;
  cursor: pointer;
  color: var(--brand-primary-40);
}

.MonetizationPopup__footer-b2178d {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 16px 24px 16px;
}

.MonetizationPopup__item-fca41b {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MonetizationPopup__button-c96397 {
  align-self: flex-end;
}

.MonetizationPopup__loader-e67e55 {
  margin: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MonetizationPopup/MonetizationPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  max-width: var(--message-bubble-max-width);\n  width: 100%;\n  overflow: hidden;\n  flex: 0 1 auto;\n}\n\n.content {\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1;\n  overflow: auto;\n}\n\n.caption {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n  margin-bottom: 16px;\n}\n\n.link {\n  text-decoration: none;\n  cursor: pointer;\n  color: var(--brand-primary-40);\n}\n\n.footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 16px;\n}\n\n.item {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  padding: 12px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.button {\n  align-self: flex-end;\n}\n\n.loader {\n  margin: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MonetizationPopup__container-c27ef3`,
	"content": `MonetizationPopup__content-e969b1`,
	"caption": `MonetizationPopup__caption-e1da1f`,
	"link": `MonetizationPopup__link-a3ab62`,
	"footer": `MonetizationPopup__footer-b2178d`,
	"item": `MonetizationPopup__item-fca41b`,
	"button": `MonetizationPopup__button-c96397`,
	"loader": `MonetizationPopup__loader-e67e55`
};
module.exports = ___CSS_LOADER_EXPORT___;
